export const FEATURE_NAME: string = 'accountManagement';

export const ACCOUNT_MANAGEMENT_MODEL: string[] = [
  FEATURE_NAME,
  'accountManagement',
];
export const AUTH_TOKEN_MODEL: string[] = [FEATURE_NAME, 'authToken'];
